export default {
  title: 'Google Business',
  sections: {
    google_business_info: 'Información de Google Business',
    google_reviews: 'Reseñas de Google',
    settings: 'Configuración',
    danger_zone: 'Zona de peligro',
  },
  form: {
    reviews_autopilot_enabled: {
      label: 'Respuestas automáticas de IA',
    },
    reviews_autopilot_daily_limit: {
      label: 'Límite diario de respuestas automáticas de IA (mín. 1, máx. 15)',
    },
    reviews_autopilot_delay_hours: {
      label: 'Horas que deben pasar tras escribir una reseña',
    },
    unanswered_checkbox: {
      show_all_reviews: 'Mostrar todas las reseñas',
      show_only_unanswered: 'Mostrar solo sin responder',
    },
    rating_filter: {
      label: 'Filtro de valoración',
      stars_one: '{{count}} estrella',
      stars_other: '{{count}} estrellas',
    },
    sorting: {
      newest_to_oldest: 'Ordenar de más reciente a más antiguo',
      oldest_to_newest: 'Ordenar de más antiguo a más reciente',
      rating_highest_to_lowest: 'Ordenar de valoración más alta a más baja',
      rating_lowest_to_highest: 'Ordenar de valoración más baja a más alta',
    },
  },
  table: {
    pagination: {
      total_one: 'Total {{count}} reseña',
      total_other: 'Total {{count}} reseñas',
    },
  },
  modal_publish: {
    title: '¿Seguro que quieres publicar en Google?',
    buttons: {
      yes: 'Sí',
      cancel: 'Cancelar',
    },
  },
  popconfirm: {
    title: '¿Estás seguro?',
    description: 'Todos los cambios locales se sobrescribirán',
  },
  disconnect_profile: {
    title: 'Desconectar perfil',
    button: 'Continuar',
    popconfirm: {
      title: '¿Estás seguro?',
      description:
        'Esto desconectará completamente este perfil de Google del sistema FoodAmigos, incluida la sustitución automática de enlaces y el piloto automático de respuestas a reseñas.',
    },
  },
  buttons: {
    login_with_google: 'Iniciar sesión con Google',
    sync_from_google: 'Obtener versión actualizada',
    publish_to_google: 'Publicar en Google',
    previous: 'Anterior',
    next: 'Siguiente',
    save_settings: 'Guardar configuración',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    failed_to_fetch_reviews: 'Error al obtener las reseñas',
    failed_to_fetch_settings: 'Error al obtener la configuración',
    failed_to_load_google_business: 'Error al cargar Google Business',
    failed_to_publish_to_google_business: 'Error al publicar en Google Business',
    publish_access_denied:
      'Google rechazó la actualización: la cuenta de Google conectada ya no puede editar este perfil de empresa. Comprueba su acceso en Google Business Profile o vuelve a conectar con la cuenta que gestiona el restaurante.',
    failed_to_fetch_info: 'Error al obtener la versión actualizada de Google Business',
    success_publish_to_google_business: 'Publicado en Google Business correctamente',
    success_sync_from_google: 'Sincronizado desde Google Business correctamente',
    success_save_settings: 'Configuración guardada correctamente',
    failed_to_disconnect_profile: 'Error al desconectar Google Business. Por favor, contacta con el equipo técnico.',
    popup_blocked: 'Permite las ventanas emergentes en este sitio para conectar Google Business.',
    failed_to_connect: 'No se ha podido conectar Google Business. Inténtalo de nuevo.',
    no_business_profile:
      'Esta cuenta de Google no gestiona ningún perfil de empresa. Inicia sesión con la cuenta de Google que gestiona el restaurante.',
  },
  callback: {
    connecting: 'Conectando Google Business…',
    connected: 'Google Business está conectado. Puedes cerrar esta ventana.',
    cancelled: 'Se ha cancelado el inicio de sesión. Puedes cerrar esta ventana.',
    failed: 'No se ha podido conectar Google Business. Cierra esta ventana e inténtalo de nuevo.',
  },
  alerts: {
    no_profile: {
      title: 'Ningún lugar de Google conectado',
      description: 'Por favor, conecta el restaurante a un lugar de Google.',
      button: {
        connect: 'Conectar',
      },
    },
    unverified_location: {
      title: 'Google Business no está verificado',
      description: 'Verifica tu Google Business para continuar',
    },
  },
};
